import { Box, TextField } from '@mui/material';
import { FC } from 'react';

import LabelSwitch from 'src/components/Inputs/LabelSwitch';
import { useUserPermissions } from 'src/hooks/useUserPermissions';
import { Roles } from 'src/types/shared';

import { CollapsibleOptions } from '../CollapsibleOptions';
import { NotifyCommentFields, NotifyCommentOnChangeType, NotifyCommentValuesType } from './useNotifyComment';

type Props = {
  values: NotifyCommentValuesType;
  onChange: NotifyCommentOnChangeType;
  withSkipNotifyRecipient?: boolean;
};

enum LabelTexts {
  NOTIFY_MAILROOM = 'Notify mailroom users about comment',
  SKIP_NOTIFICATION = 'Skip notification to recipient about completed request',
}

const NotifyMairoomComment: FC<Props> = ({ values, onChange, withSkipNotifyRecipient = true }) => {
  const { isAllowed } = useUserPermissions();
  const isAdmin = isAllowed([Roles.Admin]);
  return (
    <CollapsibleOptions>
      <TextField
        sx={{ width: '100%', mt: 1, mb: 2 }}
        label="Optional Comment"
        multiline
        rows={3}
        value={values.comment}
        onChange={(e) => onChange(NotifyCommentFields.comment, e.target.value)}
      />
      <LabelSwitch
        checked={values.notifyMailroom}
        onChange={() => onChange(NotifyCommentFields.notifyMailroom, !values.notifyMailroom)}
        label={LabelTexts.NOTIFY_MAILROOM}
      />
      {isAdmin && withSkipNotifyRecipient && (
        <Box sx={{ mt: 1 }}>
          <LabelSwitch
            checked={values.skipNotifyRecipient}
            onChange={() => onChange(NotifyCommentFields.skipNotifyRecipient, !values.skipNotifyRecipient)}
            label={LabelTexts.SKIP_NOTIFICATION}
          />
        </Box>
      )}
    </CollapsibleOptions>
  );
};

export default NotifyMairoomComment;
